export enum EDirectoryPreferences {
    EXDIRECTORY = "EXDIRECTORY",
    LISTED = "LISTED",
    UNLISTED = "UNLISTED",
}
